const INITIAL_STATE = {
    carregando: false,
    mensagemErro: undefined,
    elegivel: false,
    listaBeneficios: null,
    desatualizado: false,
    solicitacao: undefined,
    excedeuQuantidadeTentativas: undefined,
    govBrInstalado: false,
    situacaoPV: undefined,
    biometria: {
        situacao: 0,
        show: false,
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PROVAVIDA_INICIANDO_PROVA_VIDA':
            return { ...state, carregando: true, mensagemErro: undefined }
        case 'PROVAVIDA_PROVA_VIDA_INICIADA':
            return { 
                ...state,
                carregando: false,
                elegivel: action.payload.elegivel,
                listaBeneficios: action.payload.listaBeneficios,
                solicitacao: action.payload.solicitacao,
                excedeuQuantidadeTentativas: action.payload.excedeuQuantidadeTentativas,
                desatualizado: action.payload.desatualizado,
                situacaoPV: action.situacaoPV,
                mensagemErro: undefined
            }
        case 'PROVAVIDA_SHOW_MENU_BIOMETRIA':
            return {
                ...state,
                biometria: {
                    situacao: state.biometria.situacao,
                    show: action.payload.show,
                },
            }
        case 'PROVAVIDA_SET_SITUACAO_BIOMETRIA':
            return {
                ...state,
                biometria: {
                    situacao: action.payload.situacao,
                    show: state.biometria.show,
                }
            }
        case 'PROVAVIDA_LIMPAR_SOLICITACAO':
            return { ...state, carregando: false, excedeuQuantidadeTentativas: undefined, situacao: undefined }
        case 'PROVAVIDA_ERRO_INICIAR_PROVA_VIDA':
        case 'PROVAVIDA_INELEGIVEL':
            return { ...state, carregando: false, mensagemErro: action.payload.mensagem, listaBeneficios: action.payload.listaBeneficios }
        case 'PROVAVIDA_LIMPAR_MSG_ERRO':
            return { ...state, carregando: false, mensagemErro: undefined }
        case 'PROVAVIDA_GOVBR_INSTALADO':
            return { ...state, carregando: false, govBrInstalado: action.payload }        
        case 'PROVAVIDA_SITUACAO_ALTERADA':
            return { ...state, situacaoPV: action.situacao}
        default:
            return state
    }
}
